module.exports = __webpack_public_path__ + "favicon-128x128.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/favicon-128x128.png
// module id = 146
// module chunks = 0